import { FetchHandler } from "../handlers/defaultFetchHandler";
import { isGetGroupResponse, isLensProto, LensProto } from "./Lens";

const BASE_PATH = "https://api-kit.snapchat.com/com.snap.camerakit.v3.Lenses";

function getRequestId(res: Response) {
    return res.headers.get("x-request-id");
}

export async function retrieveCameraKitLens(
    httpClient: FetchHandler,
    lensId: string,
    groupId: string
): Promise<LensProto> {
    const url = [BASE_PATH, "groups", groupId, "lenses", lensId].join("/");
    const response = await httpClient(url, { credentials: "include" });
    const body = await response.json();
    const lens = body.lens;
    if (!isLensProto(lens)) {
        throw new Error(
            `Expected request to ${url} to return a Lens. Got:\n\n${JSON.stringify(
                body
            )} with request-id of "${getRequestId(response)}"`
        );
    }
    return lens;
}

export async function retrieveCameraKitLensGroup(httpClient: FetchHandler, groupId: string): Promise<LensProto[]> {
    const url = [BASE_PATH, "groups", groupId].join("/");
    const response = await httpClient(url, { credentials: "include" });
    const body = await response.json();
    if (!isGetGroupResponse(body)) {
        throw new Error(
            `Expected request to ${url} to return a LensGroup. Got:\n\n${JSON.stringify(
                body
            )} with request-id of "${getRequestId(response)}"`
        );
    }
    return body.lenses;
}
